import { Alert, Button, IconButton, Paper, Stack, Typography, useTheme } from "@mui/material";
import { Children, ReactElement } from "react";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import routes from "@/constants/routes";
import { ArrowTurnBackwardIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";

type Params = {
    organizationAlias: string | undefined;
    orderId: string | undefined;
}

interface SummaryPanelProps {
    title: string;
    stepId?: string;
    error?: string;
    children: ReactElement[] | ReactElement;
    onEdit?: () => void;
}

const SummaryPanel = ({ title, stepId, error, children, onEdit }: SummaryPanelProps) => {
    const navigate = useNavigate();
    const { palette } = useTheme();
    const { organizationAlias, orderId } = useParams<Params>();

    const handleEdit = () => {
        if (!stepId) return;

        const stepUrl = organizationAlias
            ? generatePath(routes.organizations.order.checkoutForm, { organizationAlias, orderId, formId: stepId })
            : generatePath("/orders/:orderId/checkout/:formId", { orderId: orderId as string, formId: stepId });
        navigate(stepUrl + location.search);
    }

    return (
        <Stack spacing={0.5}>
            <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="center">
                <Typography variant="caption">{title}</Typography>
                <div>
                    <IconButton onClick={onEdit ?? handleEdit}>
                        <HugeiconsIcon icon={ArrowTurnBackwardIcon} color={palette.primary.dark} />
                    </IconButton>
                </div>
            </Stack>
            <Paper sx={{ p: 2 }}>
                {error ? (
                    <Alert
                        title="Errores"
                        severity="error"
                        action={
                            <Button variant="text" color="inherit" size="small" onClick={onEdit ?? handleEdit}>Completar</Button>
                        }
                        sx={{
                            marginBottom: 2,
                            alignItems: 'center',
                        }}
                    >
                        {error}
                    </Alert>
                ) : null}
                <Stack spacing={1}>
                    {Children.map(children, child => child)}
                </Stack>
            </Paper>
        </Stack>
    )
}

export default SummaryPanel;
